import { useMemo } from 'react';

/**
 * Custom hook for detecting Chrome browser for conditional styling
 * Chrome contains both "Chrome" and "Safari" in user agent, while Safari only contains "Safari"
 */
export function useBrowserDetection() {
  const isChrome = useMemo(() => {
    if (typeof window === 'undefined') return false;
    const userAgent = window.navigator.userAgent;
    // Chrome contains "Chrome" and "Safari", but Safari only contains "Safari" without "Chrome"
    return userAgent.includes('Chrome') && userAgent.includes('Safari');
  }, []);

  const isSafari = useMemo(() => {
    if (typeof window === 'undefined') return false;
    const userAgent = window.navigator.userAgent;
    // Safari contains "Safari" but not "Chrome"
    return userAgent.includes('Safari') && !userAgent.includes('Chrome');
  }, []);

  const isMobileSafari = useMemo(() => {
    if (typeof window === 'undefined') return false;
    const userAgent = window.navigator.userAgent;
    // Mobile Safari detection: contains Safari, Mobile, and no Chrome
    return userAgent.includes('Safari') && 
           !userAgent.includes('Chrome') && 
           (userAgent.includes('Mobile') || userAgent.includes('iPhone') || userAgent.includes('iPad'));
  }, []);

  const isFirefox = useMemo(() => {
    if (typeof window === 'undefined') return false;
    const userAgent = window.navigator.userAgent;
    return userAgent.includes('Firefox');
  }, []);

  const isEdge = useMemo(() => {
    if (typeof window === 'undefined') return false;
    const userAgent = window.navigator.userAgent;
    return userAgent.includes('Edg');
  }, []);

  return {
    isChrome,
    isSafari,
    isMobileSafari,
    isFirefox,
    isEdge,
    userAgent: typeof window !== 'undefined' ? window.navigator.userAgent : '',
  };
}